import React, { useEffect } from 'react';
import { Image, View } from 'react-native';
import { Icon } from 'react-native-elements';
import { useDispatch, useSelector } from 'react-redux';
import Colors from '../../../constants/Colorsv2';
import { Text, TouchableOpacity } from '../../../globalComponents/NativeOverrides';
import { event_getEventByEventId, event_getExoticById } from '../../../store/actionsv1/events';
import { market_setDraftOrder } from '../../../store/actionsv1/markets';
import { EventOrderStatProps, MarketProps, TradeProps } from '../../../store/types/mk_svc';
import { TournamentProps, EventProps, ExoticProps } from '../../../store/types/sr_svc';
import { PlayerPickProps } from '../../../store/types/tp_svc';
import { trade_getOrderFromTrade } from '../helpers/trades';
import MarketCard from './MarketCard';
import MarketCardFooter from './MarketCardFooter';

type ExoticMarketCardProps = {
    navigation:any,
    event_id: string,
    event_type: 'team'|'tournament'|'match';
    market_override?:MarketProps,
    picks?:PlayerPickProps[],
    close_markets?:boolean,
    hide_event_info?:boolean,
    trades_override?:TradeProps[],
    lock_markets?:boolean,
    source?:'market'|'competition_create'|'competition_play'
    onCompPick?: (trade:TradeProps) => void
    add_to_comp_value?: boolean,
    onAddToComp?: (event:EventProps) => void
    exotic_id?: string,
    hide_market_footers?:boolean,
}

const ExoticMarketCard = ({ navigation, exotic_id, picks, hide_market_footers, source, trades_override, onCompPick, onAddToComp, market_override, event_id, event_type, close_markets, lock_markets }:ExoticMarketCardProps) => {

    const dispatch = useDispatch();
    const event:EventProps | undefined = useSelector((state:any) => state.event.events[event_id], (left, right) => left?.time_detail === right?.time_detail)
    const tournament:TournamentProps | undefined = useSelector((state:any) =>  state.event.tournaments[event_id], (left, right) => left?.tournament_id == right?.tournament_id)
    const exotics_list: { updated:number, exotics: ExoticProps[] } = useSelector((state:any) => state.event.exotics_list, (left, right) => left.updated == right.updated);
    const exotic = exotics_list.exotics.find(e => e.exotic_id == exotic_id);
    const markets:MarketProps[] = useSelector((state:any) => state.market.markets, (left, right) => left.length === right.length)
    
    let order_stats:EventOrderStatProps[] | undefined = useSelector((state:any) => state.market.order_stats[`${event_type}:${event_id}`], (left, right) => left == right)
    if(!order_stats){ order_stats = [] }
    order_stats = order_stats.filter(os => os.side_id == exotic_id && market_override?.market_id == os.market_id)
    const open_order_count = order_stats.reduce((a,b) => a + parseInt(b.open_order_count), 0)
    const open_order_amount = order_stats.reduce((a,b) => a + parseFloat(b.open_order_amount), 0)
    


    useEffect(() => {
        getDataFromServer();
    },[])

    const getDataFromServer = async() => {
        if(!exotic && exotic_id){ await dispatch(event_getExoticById(exotic_id)) }
        if(event_type === 'team' && !event){ await dispatch(event_getEventByEventId(event_id)) }
        //Need to add for tournament or match
    }

    const handleNavToMarket = () => {
        if(!market_override){ return }
        return navigation.push('Market', { event_type, event_id, market_id: market_override.market_id, participant_id:exotic?.exotic_id })
    }


    const handleSelectTrade = (trade:TradeProps) => {
        if(event_type === 'team' && !event){ return }
        if(event_type === 'tournament' && !tournament){ return }
        //if(!exotic){ return }
        if(source === 'competition_create'){ return }
        if(source === 'competition_play'){
            if(!onCompPick){ return }
            return onCompPick(trade)
        }
        return dispatch(market_setDraftOrder(trade_getOrderFromTrade(trade)))
    }

    if(!market_override){ return <></> }

    let side_array:any = []
    market_override.side_options.map(o => {
        let side:any = { side: o.side }
        if(o.id_source === 'exotic'){ side.side_id = exotic_id }
        else { side.side_id = o.side }
        side_array.push(side)
    })
    let pick = undefined
    if(picks && picks.length > 0){
        pick = picks.find(p => p.market_id == market_override.market_id)
    }

    return (
        <View style={styles.cardStyle}>
            <View style={{ flexDirection:'row', alignItems:'center', padding:10 }}>
                {exotic?.image?.url ?
                <View style={{ padding:10 }}>
                    <Image
                        source={{ uri: exotic.image.url }}
                        style={{ height:40, width:40, borderRadius:100 }}
                        resizeMode='cover'
                    />
                </View>
                :<></>}
                    <View nativeID='athlete-info' style={{ flex:1 }}>
                        <Text size={14} color={Colors.brand.midnight} weight='bold'>{exotic?.name}</Text>
                        <Text size={14} color={Colors.brand.midnight} weight='bold'>{market_override.description}</Text>
                    </View>
                    {!close_markets && !lock_markets ?
                    <View style={{ flex:1 }}>
                        <View style={{flex:1}}>
                            <MarketCard 
                                align='horizontal' 
                                market={market_override} 
                                pick={pick}
                                source={source}
                                side_array={side_array} 
                                trades_override={trades_override}
                                event_id={event_id} 
                                event_type={event_type} 
                                onPress={(trade) => handleSelectTrade(trade)}
                                />
                        </View>
                    </View>
                    :
                    <View style={{ flex:1, justifyContent:'center', alignItems:'center' }}>
                        <Icon name='lock' type='feather' color={Colors.brand.midnight} size={28}/>
                    </View>
                    }
                </View>
                <View nativeID='footer' style={{ backgroundColor:Colors.shades.shade100, borderBottomRightRadius:12, borderBottomLeftRadius:12 }}>
                {!hide_market_footers && !close_markets ?
                <View style={{ flexDirection:'row'}}>
                    <TouchableOpacity style={{ flex:1, padding:3, paddingLeft:10, flexDirection:'row', alignItems:'center' }} onPress={() => navigation.push('Market', { event_type, event_id, market_id: market_override.market_id, participant_id:exotic_id })}>
                        <View style={{ padding:7, borderRadius:100, backgroundColor:Colors.shades.shade600 }}>
                            <Icon name='bar-chart' type='feather' color={Colors.brand.electric} size={12} />
                        </View>
                        <View style={{ flex:1, padding:7 }}>
                            <Text size={12} color={Colors.brand.midnight}>Liquidity</Text>
                            <Text size={12} color={Colors.brand.electric} weight='bold'>${open_order_amount.toFixed()} • {open_order_count} Open Orders</Text>
                        </View> 
                    </TouchableOpacity>             
                </View>
                :<></>}
            </View>
        </View>
    )
}

const styles = {
    cardStyle: { borderRadius: 12, borderWidth: 1, borderColor: Colors.shades.shade400 }
}

export default ExoticMarketCard